define('app-UKTSBookingSummary/main',['text!./ConfirmationPrompt/view.html', '../app/ui/dialog', 'knockout'], function (view, dialogue, ko) {
    return {

        completeBooking: function (querystring) {
            dialogue.show('Please wait', '', { noClose: true, width: '30%' });
            $.get('/BookUKTravelService/Continue', { querystring: querystring }, function (confirm) {
                window.location.href = confirm.returnURL;
            });
        },

        run: function() {
            if ($('#UKTSBookingSummary').length === 0) {
                return;
            }
                
            var thisModule = this;

            var confirmationDialog;
            var querystring = window.location.search;
            querystring = querystring.substring(1);

            var vm = new function() {
                var self = this;
                self.Continue = function() {
                    var cost = $("#uktsTotalCost").val(),
                        content = "You are about to book the VIP door-to-door car service for �" + cost + ". Would you like to proceed?";
                    view = view.replace('{content}', content);
                    confirmationDialog = dialogue.show('UK Travel', view, { noClose: true, width: '35%' });
                    return;
                };
            }

            ko.applyBindings(vm, $('#UKTSBookingSummary')[0]);

            $('body').on('click', '.uk-travel-dialog-button', function (event) {
                var tar = $(event.target);
                tar.data("book").toLowerCase() == "no" ? confirmationDialog.close() : thisModule.completeBooking(querystring);
            });
        }
    };
});
